import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActiveGroupState = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		opacity: .8,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M9.83333 3.25H4.25C3.69772 3.25 3.25 3.69772 3.25 4.25V9.83333C3.25 10.3856 3.69772 10.8333 4.25 10.8333H9.83333C10.3856 10.8333 10.8333 10.3856 10.8333 9.83333V4.25C10.8333 3.69772 10.3856 3.25 9.83333 3.25Z",
				stroke: "#657900",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.75 3.25H16.1667C15.6144 3.25 15.1667 3.69772 15.1667 4.25V9.83333C15.1667 10.3856 15.6144 10.8333 16.1667 10.8333H21.75C22.3023 10.8333 22.75 10.3856 22.75 9.83333V4.25C22.75 3.69772 22.3023 3.25 21.75 3.25Z",
				stroke: "#657900",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.75 15.166H16.1667C15.6144 15.166 15.1667 15.6137 15.1667 16.166V21.7493C15.1667 22.3016 15.6144 22.7493 16.1667 22.7493H21.75C22.3023 22.7493 22.75 22.3016 22.75 21.7493V16.166C22.75 15.6137 22.3023 15.166 21.75 15.166Z",
				stroke: "#657900",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.83333 15.166H4.25C3.69772 15.166 3.25 15.6137 3.25 16.166V21.7493C3.25 22.3016 3.69772 22.7493 4.25 22.7493H9.83333C10.3856 22.7493 10.8333 22.3016 10.8333 21.7493V16.166C10.8333 15.6137 10.3856 15.166 9.83333 15.166Z",
				stroke: "#657900",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgActiveGroupState;
